import React, { useState } from 'react';

import { ConfirmDialog, Typography } from '@occc-app/design-system';
import { TextField } from '@occc-app/design-system/components/TextField';
import { formatPhoneNumberToE164 } from '@occc/utils-phone-number';

export type MemberDeleteModalProps = {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  memberPhone: string;
  isDeletionInProgress: boolean;
};

const MemberDeleteModal: React.FC<MemberDeleteModalProps> = (props) => {
  const { show, onHide, onConfirm, memberPhone, isDeletionInProgress } = props;
  const [value, setValue] = useState<string>('');

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => setValue(e.target.value);

  return (
    <ConfirmDialog
      dialogTitle='Delete Membership'
      open={show}
      onClose={onHide}
      confirmButtonText='Delete'
      confirmButtonProps={{
        onClick: onConfirm,
        color: 'error',
        disabled: formatPhoneNumberToE164(value) !== memberPhone,
      }}
      sx={{
        '& .MuiDialogContent-root': {
          paddingY: 0,
        },
      }}
      showLoadingOverlay={isDeletionInProgress}
    >
      <Typography gutterBottom={true}>
        Are you sure you would like to delete this member? This should not be done unless the member
        has specifically requested this.
      </Typography>
      <Typography>To confirm, type the member’s phone number below.</Typography>
      <TextField
        fullWidth
        name='memberPhone'
        label='Member phone number'
        margin='normal'
        onChange={handleChange}
      />
    </ConfirmDialog>
  );
};

export default MemberDeleteModal;
